import React from "react";
import PropTypes from "prop-types";
import { Body as ModalBody } from "MODULES/shared/components/Modal";

export default function Body({ prompt }) {
  return (
    <ModalBody>
      <div>
        <div className="center-block alert alert-warning">
          <div className="media">
            <div className="media-left">
              <i className="fa fa-lg fa-warning text-warning" />
            </div>
            <div className="media-body">{prompt}</div>
          </div>
        </div>
      </div>
    </ModalBody>
  );
}

Body.propTypes = {
  prompt: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Notifications/components/Search/MarkAllRead/Body.jsx